
export const text = `

Spiralling ever downward, how do things connect?

In what order? In what layer?
`